export type EventFulfillmentScanMode = 'picking' | 'returning';

const INVENTORY_FIRM_EVENT_STATUSES = new Set([
  'confirmed',
  'picking',
  'partially_filled',
  'filled',
  'partially_shipped',
  'shipped',
  'on_rent',
  'partially_returned',
  'returning',
]);

const RETURN_DEFAULT_EVENT_STATUSES = new Set([
  'shipped',
  'on_rent',
  'partially_returned',
  'returning',
  'returned',
  'ready_to_invoice',
  'invoiced',
  'closed',
  'cancelled',
  'lost',
  'void',
]);

const RETURN_ONLY_EVENT_STATUSES = new Set([
  'returned',
  'ready_to_invoice',
  'invoiced',
  'closed',
  'cancelled',
  'lost',
  'void',
]);

const normalizeStatus = (status: string | null | undefined): string =>
  String(status ?? '').trim().toLowerCase();

export function canOpenEventFulfillmentScanner(
  status: string | null | undefined,
): boolean {
  const normalized = normalizeStatus(status);
  return INVENTORY_FIRM_EVENT_STATUSES.has(normalized)
    || RETURN_ONLY_EVENT_STATUSES.has(normalized);
}

export function canPickEventFulfillment(
  status: string | null | undefined,
): boolean {
  return INVENTORY_FIRM_EVENT_STATUSES.has(normalizeStatus(status));
}

export function defaultEventFulfillmentScanMode(
  status: string | null | undefined,
): EventFulfillmentScanMode {
  return RETURN_DEFAULT_EVENT_STATUSES.has(normalizeStatus(status))
    ? 'returning'
    : 'picking';
}
